import { NgxLoggerLevel } from "ngx-logger";

export const environment = {
  production: true,
  API_URL: '/api/',
  DOC_URL: '/docs/',
  logLevel: NgxLoggerLevel.OFF,        // 👈 no imprime nada
  serverLogLevel: NgxLoggerLevel.OFF,  // 👈 y no envía nada al servidor
  serverLoggingUrl: '',
};
